import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "header-content admin-header-content"
};
const _hoisted_3 = {
  class: "header-action"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DashboardTabs = _resolveComponent("DashboardTabs");
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_el_header = _resolveComponent("el-header");
  const _component_SysConfigTabs = _resolveComponent("SysConfigTabs");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_header, null, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_DashboardTabs, {
      activeTab: "systemConfig"
    }), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_tooltip, {
      disabled: $options.disableTooltip,
      content: _ctx.$t('sysConfig.logout'),
      placement: "bottom"
    }, {
      default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
        icon: "sign-out-alt",
        class: "header-icon",
        onClick: $options.handleLogout
      }, null, 8, ["onClick"])]),
      _: 1
    }, 8, ["disabled", "content"])])])]),
    _: 1
  }), _createVNode(_component_SysConfigTabs, {
    activeIndex: $data.activeIndex,
    "onUpdate:activeIndex": _cache[0] || (_cache[0] = $event => $data.activeIndex = $event),
    isCollapse: $data.isSidebarCollapse,
    "onUpdate:isCollapse": _cache[1] || (_cache[1] = $event => $data.isSidebarCollapse = $event)
  }, null, 8, ["activeIndex", "isCollapse"]), (_openBlock(), _createBlock(_resolveDynamicComponent($options.currentComponent), {
    class: _normalizeClass(['main-container', {
      'collapsed': $data.isSidebarCollapse
    }])
  }, null, 8, ["class"]))]);
}